export const busLogs = {
  tabs: {
    queryBus: 'Query bus',
    commandBus: 'Command bus',
  },
  filters: {
    key: 'Klucz',
    user: 'Uzytkownik',
    onlyFailed: 'Tylko bledne',
    dateFrom: 'Data od',
    dateTo: 'Data do',
  },
  detail: {
    payload: 'Payload',
    errorMessage: 'Komunikat bledu',
  },
  refresh: 'Odswiez',
  noPermission: 'Brak uprawnienia: {permission}',
}
